const PLACEHOLDER_ORG_IDS = new Set(["all", "unknown"]);

export function isPlaceholderOrgId(
	orgId: string | null | undefined,
): boolean {
	return !orgId || PLACEHOLDER_ORG_IDS.has(orgId);
}
